import { Flows } from '../../../util/Types/Folder';
import type { SpaceOption } from './types';

const VIRTUAL_FOLDER_REGEX =
  /^(.+?)-(Agents|Fluxbots|Objects|Vector Memory|Shared|AgentsCategory|FluxbotsCategory|ObjectsCategory|AllFolders)$/;

const SPACE_FOLDER_REGEX = /^(.+?)-(Agents|Fluxbots|Objects|Vector Memory)$/;

export const isFluxbotFlow = (
  flow: Flows,
  rootFolderName?: string,
): boolean => {
  const folderNameLower = rootFolderName?.toLowerCase() || '';

  return (
    folderNameLower === 'chatbot' ||
    folderNameLower === 'fluxbots' ||
    flow.type === 'chat' ||
    !!flow.isChatbot ||
    !!flow.isFluxbot ||
    !!flow.chatbotDataInputNodeId ||
    !!flow.chatbotDataOutputNodeId ||
    !!flow.chatbotVoice ||
    !!flow.chatbotVoiceModel ||
    !!flow.chatImage ||
    !!flow.chatDescription
  );
};

export const isFormFlow = (flow: Flows): boolean => {
  return flow.isForm === true;
};

export const isVirtualFolderId = (folderId: string): boolean => {
  return VIRTUAL_FOLDER_REGEX.test(folderId);
};

export const parseSpaceIdFromFolderId = (
  folderId: string,
): string | undefined => {
  const match = folderId.match(SPACE_FOLDER_REGEX);
  if (match && match[1] !== 'private') {
    return match[1];
  }
  return undefined;
};

export const isVirtualFolderIdBasic = (folderId: string): boolean => {
  return SPACE_FOLDER_REGEX.test(folderId);
};

export const getFluxbotVirtualFolderId = (
  flow: Flows,
  spaces: SpaceOption[],
): string => {
  const sid =
    flow.spaceId || (typeof flow.space === 'string' ? flow.space : undefined);
  if (sid && spaces.some(s => s.id === sid)) {
    return `${sid}-Fluxbots`;
  }
  return 'private-Fluxbots';
};

export const getSpaceName = (item: Flows, spaces: SpaceOption[]): string => {
  if (item.spaceName) return item.spaceName;
  if (item.spaceId) {
    const space = spaces.find(s => s.id === item.spaceId);
    if (space) return space.name;
  }
  if (item.space) {
    if (typeof item.space === 'string') {
      const space = spaces.find(s => s.id === item.space);
      if (space) return space.name;
      return item.space;
    }
    if (item.space.name) return item.space.name;
  }
  return 'Private';
};
